import { useTranslation } from "react-i18next";
import { LegalPageLayout } from "../components/layout/LegalPageLayout";
import { SEO } from "../components/seo/SEO";
import { AGBContentDe } from "./legal/AGBContentDe";
import { AGBContentEn } from "./legal/AGBContentEn";

export default function AGB() {
  const { t, i18n } = useTranslation();
  const isEnglish = i18n.language.startsWith("en");

  return (
    <>
      <SEO
        title={`${isEnglish ? "Terms" : "AGB"} | Equna`}
        description={t("legal.seo.termsDescription")}
        canonical="/agb"
      />
      <LegalPageLayout title={isEnglish ? "Terms and Conditions" : "Allgemeine Geschäftsbedingungen (AGB)"}>
        {isEnglish ? <AGBContentEn /> : <AGBContentDe />}
      </LegalPageLayout>
    </>
  );
}
